<template>
	<div>
		<el-slider v-if="!disabled && !readonly" :marks="marks" :size="size" :value="value" :min="min" :max="max" :range="range" @input="change">
		</el-slider>
		<el-input v-else :size="size" :value="value" :readonly="readonly" :disabled="disabled"></el-input>

	</div>
</template>
<script>
	import selectBase from '@_system/components/base/select.js'
	export default {
		mixins: [selectBase],
		props: {
			marks: {
				default: () => {
					return null
				}
			},
			range: {
				default: () => {
					return false
				}
			}
		},
		data() {
			return {
			
			}
		},
		created() {

		},
		mounted() {


		},
		watch: {

		},
		computed: {

		},
		methods: {
			change(val) {
				this.$emit('input', Object.hasOwn(val, 'value') ? val.value : val)
			},
		}
	}
</script>
<style scope>

</style>
